import React, { useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { klikNaRiadok } from "../../../utils/klikNaRiadok";
import { Form } from "antd";
import { Table } from "ant-table-extensions";
import FeatherIcon from "feather-icons-react";
import { UserTableStyleWrapper } from "../../pages/style";
import { TableWrapper } from "../../styled";

import { Button } from "../../../components/buttons/buttons";
import { Cards } from "../../../components/cards/frame/cards-frame";

import { useMutation, useLazyQuery } from "@apollo/client";
import { ARCHIVE_CAR } from "../../../graphql/AdminMutations";
import { GET_CAR_BY_ID, GET_CARS_PAGINATED } from "../../../graphql/AdminQueries";
import { exportujDoExcelu, odkazNaAdmin } from "../../../utils/exportExcel";
import displayNotification from "../../reservation/admin/notification/notification";

import { useDispatch, useSelector } from "react-redux";
import { deleteCar } from "../../../redux/cars/actionCreator";
import { useTranslation } from "react-i18next";

import { CarDetailModalForm } from "./tabs/carDetailModalForm";

const graphqlVariables = {
  tokenMutation: process.env.REACT_APP_TOKEN_MUTATION,
};

const CarListTable = (props) => {
  const { active } = props;
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const tableData = useSelector((state) => state.cars?.cars) || [];
  const {
    total = 0,
    limit = 20,
    sendPageNumberToGrid,
    pageNumberToGrid,
  } = props;

  const [form] = Form.useForm();

  const [state, setState] = useState({
    editVisible: false,
    update: {},
  });

  const [formReadonly, setFormReadonly] = useState(true);
  const [selectedCar, setSelectedCar] = useState({});

  const carsTableData = [];

  // archive car
  const [triggerDeleteCar] = useMutation(ARCHIVE_CAR, {
    variables: graphqlVariables,
  });

  tableData.forEach((car) => {
    const {
      id,
      driver_firstname,
      driver_lastname,
      branchOffice,
      carRenter,
      carOwner,
      storage,
      storage_status,
    } = car;
    const company = branchOffice?.company || null;
    const link = "/admin/car/edit/" + id;
    let storageNumber = "";
    let storageSeason = "";
    let storageDate = "";
    let speedometer = 0;
    if (storage && storage.length > 0) {
      // storage[0] je od 21.9.2026 NAJNOVSI zaznam uskladnenia (backend
      // pripaja len ten). Predtym sa tu ukazoval najstarsi zaznam auta.
      storageNumber = storage[0].number;
      speedometer = storage[0].speedometer;
      storageSeason = storage[0].season || "";
      storageDate = storage[0].date
        ? new Date(storage[0].date).toLocaleDateString("sk-SK")
        : "";
    }
    return carsTableData.push({
      key: id,
      licence_plate: (
        <Link key={id} to={`/admin/car/edit/${id}`}>
          <span className={`status-text`}>{car?.licence_plate}</span>
        </Link>
      ),
      // Klik na riadok otvara vozidlo, preto si drzime aj cely zaznam.
      zaznamId: id,
      zaznam: car,
      // VIN a model su tu preto, ze sa podla nich filtruje aj hlada.
      // Bez stlpca sa vysledok filtra nedal na obrazovke overit.
      vin: car?.vin || "",
      vozidlo: car?.type || "",
      link: process.env.REACT_APP_URL + "/admin/car/edit/" + id,
      firstname: driver_firstname,
      lastname: driver_lastname,
      company: company,
      owner: carOwner?.company || null,
      renter: carRenter?.company || null,
      storageNumber: storageNumber || null,
      storageSeason: storageSeason || null,
      storageDate: storageDate || null,
      speedometer: speedometer || null,
      storage_status: storage_status || null,
      // Zlucene bunky pre uzsiu tabulku. Povodne stlpce ostavaju v datach,
      // lebo z nich cita export do Excelu a filtrovanie.
      ecvBunka: (
        <Dvojriadok
          hlavne={
            <Link key={id} to={`/admin/car/edit/${id}`}>
              <span className={`status-text`}>{car?.licence_plate}</span>
            </Link>
          }
          vedlajsie={company}
        />
      ),
      vozidloBunka: <Dvojriadok hlavne={car?.type} vedlajsie={car?.vin} />,
      firmyBunka: (
        <Dvojriadok
          hlavne={carOwner?.company}
          vedlajsie={carRenter?.company}
        />
      ),
      skladBunka: (
        <Dvojriadok
          hlavne={[storageSeason, storageDate].filter(Boolean).join(" · ")}
          vedlajsie={storageNumber ? `č. ${storageNumber}` : ""}
        />
      ),
      vodicBunka: (
        <Dvojriadok
          hlavne={[driver_firstname, driver_lastname].filter(Boolean).join(" ")}
          vedlajsie={speedometer ? `${speedometer} km` : ""}
        />
      ),
      // Oko aj ceruzka su prec: cely riadok otvara detail vozidla.
      // V akciach ostava len to, co sa z detailu spravit neda.
      action: (
        <div className="table-actions" onClick={(e) => e.stopPropagation()}>
          <>
            {active && (
              <Button
                onClick={() => onHandleDelete(id)}
                className="btn-icon"
                type="danger"
                to="#"
                shape="circle"
                title="Presunúť do archívu"
              >
                <FeatherIcon icon="trash-2" size={16} />
              </Button>
            )}
            {!active && (
              <Button
                onClick={() => onReactivate(id)}
                className="btn-icon"
                type="info"
                to="#"
                shape="circle"
                title="Vrátiť medzi aktívne"
              >
                <FeatherIcon icon="rotate-cw" size={16} />
              </Button>
            )}
          </>
        </div>
      ),
    });
  });

  const STLPCE_EXPORTU = [
    { kluc: "ecv", popis: "EČV", sirka: 14, typ: "odkaz" },
    { kluc: "vin", popis: "VIN", sirka: 20 },
    { kluc: "vozidlo", popis: "Vozidlo", sirka: 28 },
    { kluc: "pneuservis", popis: "Pneuservis", sirka: 20 },
    { kluc: "majitel", popis: "Majiteľ", sirka: 28 },
    { kluc: "najomca", popis: "Nájomca", sirka: 28 },
    { kluc: "meno", popis: "Vodič meno", sirka: 16 },
    { kluc: "priezvisko", popis: "Vodič priezvisko", sirka: 18 },
    { kluc: "telefon", popis: "Telefón", sirka: 16 },
    { kluc: "mail", popis: "E-mail", sirka: 28 },
    { kluc: "sezona", popis: "Sezóna v sklade", sirka: 16 },
    { kluc: "uskladnene", popis: "Uskladnené dňa", sirka: 14, typ: "datum" },
    { kluc: "cisloUskladnenia", popis: "Č. uskladnenia", sirka: 16 },
    { kluc: "km", popis: "Km", sirka: 10, typ: "cislo" },
  ];

  const naRiadokExportu = (auto) => {
    const posledne = (auto?.storage || [])[0];
    return {
      ecv: {
        text: auto?.licence_plate || "",
        url: odkazNaAdmin(`/admin/car/edit/${auto?.id}`),
      },
      vin: auto?.vin,
      vozidlo: auto?.type,
      pneuservis: auto?.branchOffice?.company,
      majitel: auto?.carOwner?.company,
      najomca: auto?.carRenter?.company,
      meno: auto?.driver_firstname,
      priezvisko: auto?.driver_lastname,
      telefon: auto?.driver_phone,
      mail: auto?.driver_email,
      sezona: posledne?.season,
      uskladnene: posledne?.date,
      cisloUskladnenia: posledne?.number,
      km: posledne?.speedometer,
    };
  };

  // Export berie VSETKY vyfiltrovane vozidla, nie len zobrazenu stranu.
  const [nacitajNaExport, exportStav] = useLazyQuery(GET_CARS_PAGINATED, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      const zaznamy = data?.getCarsPaginated?.items || [];
      exportujDoExcelu({
        nazovSuboru: active ? "vozidla" : "vozidla-archiv",
        nazovHarku: active ? "Vozidlá" : "Vozidlá archív",
        stlpce: STLPCE_EXPORTU,
        riadky: zaznamy.map(naRiadokExportu),
        info: { Zoznam: active ? "aktívne vozidlá" : "archív vozidiel" },
      });
    },
    onError: () => {
      displayNotification(
        "error",
        "Export",
        "Export sa nepodarilo pripraviť, skúste to znova."
      );
    },
  });

  const handleDownload = () => {
    nacitajNaExport({
      variables: {
        ...(props.queryVariables || {}),
        tokenGet: process.env.REACT_APP_TOKEN_GET,
        limit: 0,
        offset: 0,
      },
    });
  };

  // Zoznam ma k autu len NAJNOVSIU uskladnenku (kvoli rychlosti), takze
  // zalozky Uskladnenia, Rezervacie a Servisne zasahy by v okne ukazali
  // jediny zaznam. Pri otvoreni auta si preto vypytame cele auto zo servera.
  // network-only je nutne: Apollo si drzi polia podla id auta a vratil by
  // orezanu verziu zo zoznamu. Overene na BL054HG, 6.10.2026.
  const [nacitajCeleAuto] = useLazyQuery(GET_CAR_BY_ID, {
    fetchPolicy: "network-only",
    onCompleted: (udaje) => {
      const cele = udaje?.getCars && udaje.getCars[0];
      if (cele) setSelectedCar(cele);
    },
  });

  const showEditModal = (data, type = "view") => {
    setEditFormFieldsValues(data);
    if (type === "edit") {
      setFormReadonly(false);
    } else {
      setFormReadonly(true);
    }
    setState({
      ...state,
      editVisible: true,
      update: data,
    });
    setSelectedCar(data);
    if (data?.id) {
      nacitajCeleAuto({
        variables: {
          tokenGet: process.env.REACT_APP_TOKEN_GET,
          carId: data.id,
        },
      });
    }
  };

  const onHandleDelete = (id) => {
    const confirm = window.confirm(t("car.deleteCarQuestion"));
    if (confirm) {
      const variables = {
        ...graphqlVariables,
        carId: parseInt(id),
        active: false,
      };

      triggerDeleteCar({ variables }).then(({ data }) => {
        const response = data?.archiveCar;
        if (response.sucessful) {
          dispatch(deleteCar(id));
        }
      });
    }
  };

  const onReactivate = (id) => {
    const confirm = window.confirm("Chcete zaktivovať vozidlo?");
    if (confirm) {
      const variables = {
        ...graphqlVariables,
        carId: parseInt(id),
        active: true,
      };

      triggerDeleteCar({ variables }).then(({ data }) => {
        const response = data?.archiveCar;
        if (response.sucessful) {
          dispatch(deleteCar(id));
        }
      });
    }
  };

  const setEditFormFieldsValues = (carInfo) => {
    const normalizeBoolean = (value) => {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value === "string")
        return value === "1" || value.toLowerCase() === "true";
      return false;
    };
    updateFormFieldValue("licence_plate", carInfo?.licence_plate);
    updateFormFieldValue("firstname", carInfo?.driver_firstname);
    updateFormFieldValue("lastname", carInfo?.driver_lastname);
    updateFormFieldValue("phone", carInfo?.driver_phone);
    updateFormFieldValue("email", carInfo?.driver_email);
    updateFormFieldValue("sendSms", normalizeBoolean(carInfo?.sendSms));
    updateFormFieldValue("note", carInfo?.note);
    updateFormFieldValue("type", carInfo?.type);
    // Bez tohto riadku sa VIN do formulara nenacital a ulozenie karty ho
    // prepisalo na prazdno, lebo values.vin bolo undefined.
    updateFormFieldValue("vin", carInfo?.vin);

    updateFormFieldValue("company", carInfo?.branchOffice?.company);
    updateFormFieldValue("owner", carInfo?.carOwner?.company);
    updateFormFieldValue("renter", carInfo?.carRenter?.company);
    updateFormFieldValue(
      "storage_status",
      normalizeBoolean(carInfo?.storage_status),
    );
  };

  const updateFormFieldValue = useCallback(
    (fieldKey, fieldValue) => {
      form.setFieldsValue({ [fieldKey]: fieldValue });
    },
    [form],
  );

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        <Button
          className="btn-export"
          onClick={handleDownload}
          type="primary"
          disabled={exportStav?.loading}
        >
          {exportStav?.loading ? "Pripravujem export..." : "Export do Excelu"}
        </Button>
        <TableWrapper className="table-responsive">
          <Table
            scroll={{ x: "max-content" }}
            dataSource={carsTableData}
            columns={getCarsTableColumns(t)}
            loading={props.loading}
            rowClassName={() => "riadok-klikatelny"}
            onRow={(record) =>
              klikNaRiadok({
                cesta: `/admin/car/edit/${record?.zaznamId}`,
                akcia: () => {
                  // Modal ma vsetko naraz: udaje aj historiu vozidla.
                  // V archive sa nedaju menit udaje, tam je len na citanie.
                  if (record?.zaznam) {
                    showEditModal(record.zaznam, active ? "edit" : "view");
                  }
                },
              })
            }
            pagination={{
              defaultPageSize: limit,
              total: total,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items",
                )}`,
              position: ["topLeft", "bottomLeft"],
              current: pageNumberToGrid || 1,
              onChange: sendPageNumberToGrid,
            }}
            onChange={(pagination) => {
              const data = {
                pageNumber: pagination.current,
                pageSize: pagination.pageSize,
              };
              sendPageNumberToGrid && sendPageNumberToGrid(data);
            }}
            // exportableProps={{
            //   fileName: "zoznam-vozidiel",
            //   // showColumnPicker: true,
            //   fields,
            //   btnProps: {
            //     type: "primary",
            //     children: <span>Export do CSV</span>,
            //   },
            // }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
      <CarDetailModalForm
        t={t}
        tableData={tableData}
        data={props}
        formReadonly={formReadonly}
        form={form}
        graphqlVariables={graphqlVariables}
        selectedCar={selectedCar}
        setState={setState}
        showModal={state.editVisible}
      />
    </Cards>
  );
};

// Dve informacie v jednej bunke: hlavna a pod nou drobnym pismom doplnujuca.
// Zoznam vozidiel mal trinast stlpcov a na bezneho monitora sa nezmestil,
// takze sa musel posuvat do boku. Suvisiace udaje teraz drzime spolu.
const Dvojriadok = ({ hlavne, vedlajsie }) => (
  <div style={{ lineHeight: 1.3 }}>
    <div>{hlavne || "—"}</div>
    {vedlajsie ? (
      <div style={{ fontSize: "11px", color: "#868eae", marginTop: "2px" }}>
        {vedlajsie}
      </div>
    ) : null}
  </div>
);

const getCarsTableColumns = (t) => {
  return [
    {
      title: t("car.licencePlate"),
      dataIndex: "ecvBunka",
      key: "ecvBunka",
      width: "150px",
    },
    {
      title: t("car.type"),
      dataIndex: "vozidloBunka",
      key: "vozidloBunka",
    },
    {
      title: t("car.owner") + " / " + t("car.renter"),
      dataIndex: "firmyBunka",
      key: "firmyBunka",
    },
    {
      title: "Uskladnenie",
      dataIndex: "skladBunka",
      key: "skladBunka",
    },
    {
      title: t("car.driverFirstname"),
      dataIndex: "vodicBunka",
      key: "vodicBunka",
    },
    {
      title: t("common.actions"),
      dataIndex: "action",
      key: "action",
      width: "90px",
    },
    {
      title: "Link",
      dataIndex: "link",
      key: "link",
      hidden: true,
    },
  ].filter((item) => !item.hidden);
};

export default CarListTable;
